import React from 'react';

import { SvgIcon, SvgIconProps } from '@mui/material';

const path =
  'M6.643.068a1.074 1.074 0 0 0-.577.592C6.005.839 6 1.73 6 12c0 12.509-.029 11.373.3 11.702.322.322-.144.3 6.242.289l5.678-.011.189-.111c.213-.125.375-.318.454-.539.08-.223.08-22.437 0-22.66a1.038 1.038 0 0 0-.454-.539L18.22.02l-5.7-.007c-5.084-.006-5.719 0-5.877.055M17.43 12.01l-.01 10.49-4.95.01-4.95.01v-21h9.92l-.01 10.49m-6.803-7.384c-.015.015-.027 1.266-.027 2.781v2.753h3.721l-.011-2.77-.01-2.77-1.823-.01c-1.003-.006-1.835.001-1.85.016';

const DeviceIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path d={path} />
  </SvgIcon>
);

export default DeviceIcon;
